import {
  ADDON_PAYMENTS_METHODS_FILTER_LABEL,
  ADYEN_PAYMENTS_METHODS_FILTER_LABEL,
  CHECKOUT_PNP_PAYMENTS_METHODS_FILTER_LABEL,
  FREEDOM_PAY_PAYMENTS_METHODS_FILTER_LABEL,
  NEMURU_PAYMENTS_METHODS_FILTER_LABEL,
  ORGANIZATION_TYPE,
  PAYCOMET_PAYMENTS_METHODS_FILTER_LABEL,
  PAYMENT_TYPES_VALUES,
  STRIPE_PAYMENTS_METHODS_FILTER_LABEL,
} from "../../witadmin/Common/constants";
import { Reservation } from "../domain/Reservation";
import { ReservationDto } from "./Reservation.dto";

export const toReservation = (dto: ReservationDto): Reservation => {
  let organizationName: string | undefined;
  let organizationType: string | undefined;
  if (dto.companyTicker) {
    organizationName = dto.companyTicker;
    organizationType = ORGANIZATION_TYPE.COMPANY;
  }
  if (dto.agencyTicker) {
    organizationName = dto.agencyTicker;
    organizationType = ORGANIZATION_TYPE.AGENCY;
  }

  return Reservation.of({
    ...dto,
    paymentType: getPaymentType(dto),
    deposit: dto.guaranteeAmount,
    communicationConsent: dto.customer.communicationConsent,
    organizationName,
    organizationType,
  });
};

function getPaymentType(reservation: ReservationDto): string {
  switch (reservation.paymentType) {
    case PAYMENT_TYPES_VALUES.checkout_pnp:
      return (
        CHECKOUT_PNP_PAYMENTS_METHODS_FILTER_LABEL[reservation.paymentMethod] ||
        reservation.paymentType
      );
    case PAYMENT_TYPES_VALUES.paycomet:
      return (
        PAYCOMET_PAYMENTS_METHODS_FILTER_LABEL[reservation.paymentMethod] || reservation.paymentType
      );
    case PAYMENT_TYPES_VALUES.addon_payments:
      return (
        ADDON_PAYMENTS_METHODS_FILTER_LABEL[reservation.paymentMethod] || reservation.paymentType
      );
    case PAYMENT_TYPES_VALUES.adyen:
      return (
        ADYEN_PAYMENTS_METHODS_FILTER_LABEL[reservation.paymentMethod] || reservation.paymentType
      );
    case PAYMENT_TYPES_VALUES.stripe:
      return (
        STRIPE_PAYMENTS_METHODS_FILTER_LABEL[reservation.paymentMethod] || reservation.paymentType
      );
    case PAYMENT_TYPES_VALUES.freedom_pay:
      return (
        FREEDOM_PAY_PAYMENTS_METHODS_FILTER_LABEL[reservation.paymentMethod] ||
        reservation.paymentType
      );
    case PAYMENT_TYPES_VALUES.nemuru:
      return (
        NEMURU_PAYMENTS_METHODS_FILTER_LABEL[reservation.paymentMethod] || reservation.paymentType
      );
    default:
      return PAYMENT_TYPES_VALUES[reservation.paymentType] || reservation.paymentType;
  }
}
